import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, Zap, Calendar, MessageCircle } from "lucide-react";

const RecommendedCommunities = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-300">
      <div className="flex items-center gap-1 mb-2">
        <div className="w-8 h-8 flex items-center justify-center">
          <Zap className="w-5 h-5 text-blue-800" />
        </div>
        <h3 className="text-lg font-bold text-blue-900">Get Connected</h3>
      </div>
      <p className="text-gray-500 mb-6 text-sm">Access mentors, connect with peers, and join communities.</p>
      
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-3">
          <Users className="w-4 h-4 text-gray-600" />
          <h4 className="font-semibold text-gray-900">Mentor Support</h4>
        </div>
        <div className="space-y-2">
          <button
            onClick={() => navigate("/dashboard/mentors-and-community/mentorship")}
            className="w-full text-sm py-2 px-4 rounded-lg border border-blue-600 text-blue-600 hover:bg-blue-50 transition-colors flex items-center gap-2"
          >
            <Calendar className="w-4 h-4" />
            Learning Path Review
          </button>
        </div>
      </div>

      {/* Learning Buddy Section */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <Users className="w-4 h-4 text-gray-600" />
          <h4 className="font-semibold text-gray-900">Learning Buddy</h4>
          <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full flex items-center gap-1">
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
            </svg>
            Coming Soon
          </span>
        </div>
        <div className="space-y-2">
          <div className="w-full text-sm py-2 px-4 rounded-lg border border-gray-300 text-gray-400 flex items-center gap-2 bg-gray-50">
            <Users className="w-4 h-4" />
            Find a Buddy
          </div>
        </div>
      </div>

      {/* Communities Section */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <Users className="w-4 h-4 text-gray-600" />
          <h4 className="font-semibold text-gray-900">Communities</h4>
        </div>
        <div className="space-y-2">
          <button
            onClick={() => navigate("/dashboard/mentors-and-community/community")}
            className="w-full text-sm py-2 px-4 rounded-lg border border-blue-600 text-blue-600 hover:bg-blue-50 transition-colors flex items-center gap-2"
          >
            <Users className="w-4 h-4" />
            Join Community
          </button>
        </div>
         <div className="mt-3">
          <button
            onClick={() => navigate("/dashboard/mentors-and-community/community?group=career-transition")}
            className="w-full text-sm py-2 px-4 rounded-lg border border-blue-600 text-blue-600 hover:bg-blue-50 transition-colors flex items-center gap-2"
          >
            <Users className="w-4 h-4" />
            Career Transition Support Group
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecommendedCommunities; 